import { z } from 'zod';
import { jobStatusSchema } from './job-status.schema';
import { reportTypeSchema } from './report-type.schema';

export const jobErrorSchema = z.object({
	code: z.string(),
	message: z.string(),
});

export const createJobResponseSchema = z.object({
	jobId: z.uuid(),
	reportType: reportTypeSchema,
	status: jobStatusSchema,
});

export const jobOutputResponseSchema = z.object({
	contentType: z.string(),
	fileName: z.string(),
	downloadUrl: z.url(),
});

export const jobResponseSchema = z.object({
	jobId: z.uuid(),
	reportType: reportTypeSchema,
	status: jobStatusSchema,
	requestedAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	output: jobOutputResponseSchema.optional(),
	error: jobErrorSchema.optional(),
});

export type CreateJobResponse = z.infer<typeof createJobResponseSchema>;
export type JobResponse = z.infer<typeof jobResponseSchema>;
